import styled from 'styled-components';

import { media } from '@theme/media';
import { CONTAINER_PADDING, CONTAINER_WIDTH, NARROW_CONTAINER_WIDTH } from '@components/blocks/blocks.constants';
import {
  colonSuffix,
  containerStyles,
  linkStyles,
  paragraphStyles,
  paragraphTextStyles,
} from '@components/blocks/blocks.styles';

export const Container = styled.div`
  ${paragraphTextStyles};
  ${containerStyles};
  margin: 2.8em auto;

  ${media.desktop} {
    margin: 4.2em auto;
    padding: 0;
    max-width: none;
    display: grid;
    grid-template-columns: calc(50% - ${CONTAINER_WIDTH / 2}px) ${CONTAINER_WIDTH}px auto;
  }
`;

export const QuestionContainer = styled.div`
  ${paragraphTextStyles};
  ${containerStyles};
  margin: 2.8em auto;

  ${media.tablet} {
    margin: 4.2em 0;
    display: grid;
    grid-template-columns: auto calc(${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 3) auto;
    max-width: none;
  }
`;

export const QuestionContent = styled.div`
  margin-left: calc(${CONTAINER_PADDING}px * 1.5);

  ${media.tablet} {
    margin-left: calc(
      ((-100vw + ${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 6) / 4) + ${CONTAINER_PADDING}px / 2
    );
  }
`;

export const AnswerContainer = styled.div`
  ${paragraphTextStyles};
  ${containerStyles};
  margin: 2.8em auto;

  ${media.tablet} {
    margin: 4.2em 0;
    display: grid;
    grid-template-columns: auto ${CONTAINER_WIDTH - CONTAINER_PADDING * 2}px auto;
    max-width: none;
  }
`;

export const Title = styled.h3`
  ${paragraphTextStyles};
  ${colonSuffix};
  font-weight: 500;

  ${media.desktop} {
    margin: 0 0 0 51px;
  }
`;

export const Paragraph = styled.div`
  padding-left: 0;

  a {
    ${linkStyles};
  }

  & > p {
    ${paragraphStyles};
    min-height: 1px;

    &:last-child {
      margin-bottom: 0;
    }

    ${media.desktop} {
      padding: 0 ${CONTAINER_PADDING}px;
    }
  }
`;

export const AnswerTitle = styled.span`
  ${colonSuffix};
  margin-right: calc(${CONTAINER_PADDING}px * 0.5);

  ${media.tablet} {
    float: left;
    margin-left: calc(((-100vw + ${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 6) / 2));
  }
`;

export const QuestionTitle = styled(AnswerTitle)`
  margin-right: calc(34px * 0.5);
  margin-left: calc(-34px * 1.5);

  ${media.tablet} {
    margin-left: calc(
      ((-100vw + ${NARROW_CONTAINER_WIDTH}px + ${CONTAINER_PADDING}px * 2) / 4) + ${CONTAINER_PADDING}px / 2
    );
  }
`;

export const QuestionParagraph = styled.span`
  > p {
    margin: 0 0 1.4rem;
    min-height: 1px;
  }
`;
